<template>
  <el-button
    :type="type"
    class="base-button"
    :class="[type ? 'base-button--' + type : '', size ? 'base-button--' + size : '']"
    :disabled="disabled"
    @click="$emit('click')"
    v-bind="$attrs"
  >
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: "base-button",
  props: {
    type: {
      // default、primary、text
      type: String,
      default: "default"
    },
    size: {
      // normal、large
      type: String,
      default: "normal"
    },
    disabled: Boolean
  }
}
</script>

<style lang="scss" scoped>
.base-button {
  font-size: 14px;
  // type: default
  &.base-button--default {
    color: #1989fa;
    background-color: #ffffff;
    border: 1px solid #a3d0fd;
  }
  &.base-button--default:focus,
  &.base-button--default:hover {
    background-color: #e6f1fc;
  }
  &.base-button--default:active {
    color: #3a8ee6;
    border-color: #3a8ee6;
    outline: 0;
  }
  &.base-button--default.is-disabled {
    color: #c0c4cc;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
  }
  // type: primary
  &.base-button--primary {
    color: #fff;
    background-color: #1989fa;
    border: none;
  }
  &.base-button--primary:focus,
  &.base-button--primary:hover {
    background: rgba(25, 137, 250, 0.7);
  }
  &.base-button--primary.is-active,
  &.base-button--primary:active {
    background: #3a8ee6;
    border-color: #3a8ee6;
  }
  &.base-button--primary.is-disabled {
    color: #c0c4cc;
    background: #f5f7fa;
  }
  // size: normal
  &.base-button--normal {
    height: 32px;
    line-height: 20px;
    padding: 6px 18px;
    border-radius: 4px;
  }
  // size: large
  &.base-button--large {
    height: 40px;
    font-size: 18px;
    line-height: 25px;
    padding: 8px 29px 7px 30px;
    border-radius: 4px;
  }
  // type: text
  &.base-button--text {
    color: #1989fa;
    padding-left: 0;
    padding-right: 0;
  }
  &.base-button--text:focus,
  &.base-button--text:hover {
    color: #66b1ff;
    border-color: transparent;
    background-color: transparent;
  }
  &.base-button--text:active {
    color: #1989fa;
    background-color: transparent;
  }
  &.base-button--text.is-disabled {
    color: #c0c4cc;
  }
}
</style>
